import { FC } from 'react'

import WatchCheckFileIcon from 'assets/icons/watch-cancel.svg'

import { IconStyles } from '../types'
import { WatchCancelCustom } from './WatchCancel.styles'

interface IWatchCancelIcon extends IconStyles {
  onClick?: any
}

const WatchCancelIcon: FC<IWatchCancelIcon> = ({
  onClick,
  colorIcon,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  height,
  width,
  filter = false
}) => {
  return (
    <WatchCancelCustom
      src={WatchCheckFileIcon}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={colorIcon}
      width={width}
      height={height}
      filter={filter}
    />
  )
}

export default WatchCancelIcon
